const baseAnonymousId = 'anid';
const baseSessionId = 'sid';
const angularPrefix = 'ngStorage-';
export const TELEMETRY_STORAGE_KEYS = {
  anonymousId: `${angularPrefix}${baseAnonymousId}`,
  sessionId: `${angularPrefix}${baseSessionId}`,
  angularAnonymousId: baseAnonymousId,
  angularSessionId: baseSessionId,
};
